import Header from "@/sections/Header";
import IC_NO_PERMISSION from "@/assets/record/ic_no_permission.png";
import { isMobile } from "@/utils/platform";

function SummaryPermissionError() {
  const backDisabled = isMobile();
  return (
    <div className="w-full h-full flex flex-col">
      <Header title="暂无访问权限" backDisabled={backDisabled} />
      <div className="fixed z--1 w-full h-full flex flex-col flex-justify-center flex-items-center">
        <img src={IC_NO_PERMISSION} className="w-25 h-25" />
        <div className="mt-1 text-mx-secondary text-4">暂无访问权限</div>
      </div>
    </div>
  );
}

export default SummaryPermissionError;
